import { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Button Components per UX Spec page 3
 *
 * Primary Button:
 * - Tool-colour fill
 * - White text
 * - 4px radius
 * - 32px height
 * - 12px h-padding
 * - Main CTA per screen — one per view, inherits active tool colour
 *
 * Secondary Button:
 * - Transparent bg
 * - Border-secondary stroke
 * - 4px radius
 * - Same size
 * - Secondary actions — export, filter, settings
 */

interface ButtonProps {
  variant?: 'primary' | 'secondary';
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

export function Button({
  variant = 'primary',
  children,
  onClick,
  disabled = false,
  loading = false,
  className = '',
  type = 'button',
}: ButtonProps) {
  const baseStyles = 'h-8 px-3 rounded-chip text-body font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2';

  const variantStyles = {
    primary: 'bg-t1-primary text-white hover:bg-t1-dark',
    secondary: 'bg-transparent border border-gray-300 text-gray-700 hover:bg-gray-50',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
    >
      {loading && <Loader2 className="w-4 h-4 animate-spin" />}
      {children}
    </button>
  );
}
